import { Plugin } from 'ckeditor5';
import MathEditing from './MathEditing';
import MathUI from './MathUI';

/**
 * Equations: native MathML display (MathEditing) plus MathLive editing (MathUI).
 * Toolbar items: 'math' (insert / edit), and 'mathEdit' in the equation's widget toolbar.
 */
export default class MathPlugin extends Plugin {
    static get pluginName() {
        return 'Math';
    }

    static get requires() {
        return [MathEditing, MathUI];
    }
}
